import styled from "@emotion/styled/macro";
import { AppBar, Toolbar } from "@material-ui/core";

export const StyledAppBar = styled(AppBar)`
  position: static;
  background-color: var(--color-dark);
`;
export const StyledToolbar = styled(Toolbar)``;
